import { Text } from '@chakra-ui/react';

import SectionStartTemplate from '../../../templates/sectionStart';
import { SectionStatus } from '../../../sections/types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';

export interface IProps {
  personalInfoStatus: SectionStatus;
  historyStatus: SectionStatus;
  financeStatus: SectionStatus;
  warning: string;
}

type Props = IProps;

const ConsentsSectionStart = (props: Props) => {
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      section1={props.personalInfoStatus}
      section2={props.historyStatus}
      section3={SectionStatus.todo}
      section4={props.financeStatus}
      section="Section 3 - Your Responsibilities"
      minsToComplete={5}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
    >
      <Text fontSize="lg" dangerouslySetInnerHTML={{ __html: props.warning }} />
    </SectionStartTemplate>
  );
};

export default ConsentsSectionStart;
